import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 36 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.0693359 4.3888V0.611576H35.9405V4.3888H0.0693359Z", fill: "currentColor" }));
export default SvgMinus;
